<div class="ap-destination-mobile">
<button class="ap-btn-close" mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
<mat-form-field class="ap-destination" floatLabel="never">
  <input #input
    matInput
    [placeholder]="placeholder"
    [formControl]="formSearchControl"
    (keydown)="onInputKeyboardNavigation($event)">
</mat-form-field>
</div>
<div class="ap-selected-list">
  <ng-container *ngIf="isPanelExpanded || selectedValues?.length >= groupLimit; else selectedDestinations">
    <mat-expansion-panel class="mat-elevation-z0" #expansionPanel="matExpansionPanel" (opened)="panelExpanded()" (closed)="panelCollapse()">
      <mat-expansion-panel-header>{{ expansionPanel.expanded ? 'Destinations' : destinationText() }}</mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <ng-container *ngTemplateOutlet="selectedDestinations">
        </ng-container>
      </ng-template>
    </mat-expansion-panel>
  </ng-container>

  <ng-template #selectedDestinations>
    <div (click)="remove(place)" *ngFor="let place of selectedValues" class="ap-selected-text">
      <div>{{ place.destinationType === DestinationType.Location ? place.countryName+" ("+place.name+")" : place.name }} <span>X</span></div>
    </div>
  </ng-template>

</div>
<div class="ap-destination-list" *ngIf="!isPanelExpanded">
  <mat-selection-list #selectionList
    [class.ap-selected-destinations]="isSelectedActive"
    (keydown)="onListKeyboardNavigation($event)"
    (selectionChange)="optionSelected($event)">
    <mat-option [hidden]="true"></mat-option>

    <ng-container *ngIf="!isFilterActive; else filterView">
      <mat-option *ngIf="headerText" class="ap-select-header-text" disabled="true" [innerHTML]="headerText | safeHtml"></mat-option>
      <mat-option *ngIf="isFilterActive && places?.length === 0" class="ap-select-header-text" disabled="true">{{ noMatchLabel }}</mat-option>
      <mat-list-option *ngFor="let place of places"
        [value]="place"
        [disabled]="place.destinationType === DestinationType.Region"
        [hidden]="isSelected(place)"
        [class.ap-option-indent]="place.destinationType !== DestinationType.Region"
        [class.ap-option-group]="place.destinationType === DestinationType.Region">
        {{ place.destinationType === DestinationType.Location ? place.countryName+" ("+place.name+")" : place.name }}
      </mat-list-option>
      <mat-option disabled="true" [innerHTML]="footerText | safeHtml"></mat-option>
    </ng-container>

    <ng-template #filterView>
      <mat-option *ngIf="places?.length === 0" class="ap-select-header-text" disabled="true">{{ noMatchLabel }}</mat-option>
      <mat-list-option *ngFor="let place of places"
        [value]="place"
        [disabled]="place.destinationType === DestinationType.Region"
        [hidden]="isSelected(place)"
        [class.ap-option-group]="place.destinationType === DestinationType.Region">
        {{ place.destinationType === DestinationType.Location ? place.countryName+" ("+place.name+")" : place.name }}
      </mat-list-option>
    </ng-template>
  </mat-selection-list>
</div>
<div>
  <ng-content></ng-content>
</div>